/* eslint-disable */
import { Component, Injector } from '@angular/core';
import { BaseRoute } from '../../../shared/components/base.route';

@Component({
  selector: 'ns-fund-by-broker-receipt',
  template: require('./fund-by-broker-receipt.component.html')
})

export class FundByBrokerReceiptComponent extends BaseRoute {
  constructor(injector: Injector) {
    super(injector);
    this.flowManager.fundingMethod = 'ACATS';
  }

  ngOnInit() {
    this.flowManager.hasFundedAccount = true;
    this.payload = {
      requestId: this.appActions.getData('Acats.acatsRequestId'),
      transferAmount: 'Full',
      AccountNumber: this.appActions.getData('DepositFunds.to'),
      ContraParty: {
        BrokerageFirmName: this.appActions.getData('Acats.acatsFirmName'),
        DTCNumber: this.appActions.getData('Acats.acatsFirmDTC'),
        AccountNumber: this.appActions.getData('Acats.acatsFirmAccount')
      }
    };
    this.unlistedBroker = this.flowManager.isUnlistedBroker;
  }

  btnClick(e) {
    if (e.action === 'next') {
      //authed
      if (this.flowManager.isAuthed) {
        this.flowManager.ssoToAlly();
        //sso to consolidated dash
      }
      //not authed
      else {
        this.router.navigate(['/credentials']);
        //to create user step
      }
    }
  }
}
